import Level, { LevelActionsAction } from '../Components/Level'

class LevelController {
    levels: Record<string, Level> = {}
    currentLevelId?: string
    mainMenu = document.querySelector('#main-menu') as HTMLDivElement

    constructor() {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            switch (action) {
                case LevelActionsAction.stop:
                    this.stopLevel(level.id)
                    break
                case LevelActionsAction.start:
                    console.debug('start level')
            }
        })
    }

    showMenu = () => {
        this.mainMenu.classList.remove('hidden')
    }

    hideMenu = () => {
        this.mainMenu.classList.add('hidden')
    }

    stopLevel = (levelId?: string) => {
        levelId && this.levels[levelId] && this.levels[levelId].stop()
    }

    destroyLevel = (levelId: string) => {
        this.levels[levelId] && delete this.levels[levelId]
    }

    setCurrentLevelId = (levelId: string) => {
        this.currentLevelId = levelId
    }

    startCurrentLevel = () => {
        this.currentLevelId && this.levels[this.currentLevelId].start()
    }

    loadLevel = async (levelId: string) => {
        console.debug(`Inamove::LevelController => load level ${levelId}`)

        const level = await Level.load(levelId)
        this.levels[levelId] = level

        console.debug(`Inamove::LevelController => level ${levelId} loaded`)
        return level
    }

    startLevel = (levelId: string) => {
        if (levelId === this.currentLevelId) {
            return
        }

        const level = this.levels[levelId]

        if (!level) {
            console.error(`>>>>> LevelController: startLevel: level with id "${levelId}" not loaded`)
            return
        }

        this.currentLevelId = levelId
        level.start()
    }
}

export default new LevelController()
